export const filmProfile = [
  { key: '作品名称', value: '善良的小姨子', note: '常见检索写法：善良的小姨子在线' },
  { key: '内容题材', value: '家庭情感 / 剧情类作品', note: '以人物关系与情感抉择为主线' },
  { key: '对白语言', value: '原声对白为主', note: '中文理解依赖字幕或译制版本' },
  { key: '字幕版本', value: '中文字幕、双语字幕', note: '覆盖简体中文阅读习惯' },
  { key: '译制版本', value: '中文版、国语配音', note: '适合不便阅读字幕的观众' },
  { key: '常见检索', value: '字幕在线、中字、双语', note: '对应不同的查找意图' },
];

export const storyAngles = [
  {
    icon: 'ri-heart-3-line',
    title: '情感主线',
    text: '作品以人物之间的情感关系为骨架，通过对白与细节推进情节，观众关注的重点往往落在人物如何面对家庭责任与内心选择的冲突上。',
  },
  {
    icon: 'ri-group-line',
    title: '人物关系',
    text: '围绕家庭成员之间的相处展开，人物在亲疏、误会与理解之间不断调整距离，中文字幕把这类细腻的情绪表达完整传递出来。',
  },
  {
    icon: 'ri-timer-line',
    title: '叙事节奏',
    text: '整体叙事偏生活化，段落之间留有呼吸感，观看时更适合配合字幕逐段理解，避免只看画面而遗漏对白中的关键信息。',
  },
  {
    icon: 'ri-moon-clear-line',
    title: '氛围营造',
    text: '画面与配乐共同塑造情绪基调，字幕与译制版本负责把语气与潜台词还原出来，这也是同题材作品重视翻译质量的原因。',
  },
];

export const subtitleTypes = [
  {
    icon: 'ri-movie-line',
    name: '中文字幕',
    tag: '核心',
    text: '把原声对白完整翻译成中文，覆盖日常对话、语气词与情绪表达。适合希望在保留原声语感的同时，也能顺畅看懂剧情的观众。',
  },
  {
    icon: 'ri-live-line',
    name: '字幕在线',
    tag: '即看',
    text: '以在线字幕的形式随页面呈现，打开即可阅读，不需要额外下载或安装。适合快速浏览、临时对照或在不同设备之间切换观看。',
  },
  {
    icon: 'ri-file-text-line',
    name: '中文版',
    tag: '完整',
    text: '在字幕基础之上整理的完整中文呈现版本，句子衔接与分段更贴近中文阅读习惯，适合连续观看时保持稳定的理解节奏。',
  },
  {
    icon: 'ri-mic-line',
    name: '国语',
    tag: '配音',
    text: '以中文普通话配音呈现的译制版本，把对白直接转换成听觉信息，适合不方便一直盯着字幕或更习惯听中文的观众。',
  },
  {
    icon: 'ri-article-line',
    name: '中字',
    tag: '简称',
    text: '“中字”是带中文字幕版本的常见简称写法，检索时范围更宽，通常会同时命中简体中文字幕与中文字幕在线等结果。',
  },
  {
    icon: 'ri-translate-2',
    name: '双语',
    tag: '对照',
    text: '在同一画面中同时显示原声与中文两种语言，方便逐句对照表达方式。适合想兼顾理解剧情与体会原文语感的观众。',
  },
];

export const versionRows = [
  {
    name: '中文字幕版',
    language: '原声 + 中文文本',
    audience: '想保留原声语感的观众',
    effort: '需要跟读字幕',
    note: '信息量最完整，对白细节与语气都能通过字幕体现。',
  },
  {
    name: '中文版（译制）',
    language: '中文文本呈现',
    audience: '偏好中文表达习惯的观众',
    effort: '阅读负担较低',
    note: '句子衔接更符合中文语序，适合长时间连续观看。',
  },
  {
    name: '国语配音版',
    language: '中文普通话配音',
    audience: '不便阅读字幕的观众',
    effort: '无需跟读字幕',
    note: '以听觉为主，同时关注配音对情绪的还原程度。',
  },
  {
    name: '双语字幕版',
    language: '原声 + 双语文本',
    audience: '想逐句对照的观众',
    effort: '阅读负担较高',
    note: '同一画面呈现两种语言，适合对照表达与用语。',
  },
];

export const languageTabs = [
  {
    id: 'zh',
    label: '中字',
    heading: '中文字幕：最通用的理解方式',
    intro:
      '中文字幕是最常见的语言版本，把原声对白翻译为中文并以文本形式同步呈现，兼顾原声语感与剧情理解，适合大多数观众作为默认选择。',
    points: [
      '完整覆盖对白与语气词，减少因听不懂而错过情节的情况',
      '适合想要边听原声、边看中文的观众',
      '简体中文写法在检索中最为常见，命中结果范围较广',
    ],
  },
  {
    id: 'bilingual',
    label: '双语',
    heading: '双语字幕：原声与中文逐句对照',
    intro:
      '双语字幕会在同一画面同时显示原文与中文，方便逐句对照表达方式。它对阅读速度有一定要求，但在体会原文语感方面更有优势。',
    points: [
      '同一句对白可对照两种语言的表达差异',
      '适合对用语和翻译细节比较在意的观众',
      '建议在屏幕较大或暂停查看时使用，阅读更从容',
    ],
  },
  {
    id: 'mandarin',
    label: '国语',
    heading: '国语配音：用听觉理解整部作品',
    intro:
      '国语版本以中文普通话配音呈现，把对白直接转换为听觉信息。对于不方便持续阅读字幕，或者更习惯听中文的观众来说更方便。',
    points: [
      '无需一直盯着字幕，观看时更轻松',
      '关注配音是否还原了人物的语气与情绪',
      '适合在做其他事情时以听为主地了解内容',
    ],
  },
  {
    id: 'online',
    label: '字幕在线',
    heading: '字幕在线：打开即可阅读',
    intro:
      '字幕在线指以在线形式直接加载字幕文本，无需下载文件即可阅读。它适合快速浏览、临时对照，以及在多设备之间切换观看的场景。',
    points: [
      '打开页面即可同步观看，省去下载步骤',
      '适合先快速了解内容，再决定是否深入观看',
      '网络状况会影响加载速度，建议保持连接稳定',
    ],
  },
];

export const guideSteps = [
  {
    step: '01',
    title: '先明确语言需求',
    text: '先判断自己更需要「看懂剧情」还是「保留原声语感」。前者可优先考虑中文版或国语，后者可优先考虑中文字幕与双语。',
  },
  {
    step: '02',
    title: '再确认字幕形式',
    text: '区分中文字幕、字幕在线与中字对应的具体形式。字幕在线偏向即看即读，中字是更宽泛的简称检索写法。',
  },
  {
    step: '03',
    title: '对照不同版本',
    text: '在版本对照中比较阅读负担与适合人群，选择与自己观看习惯匹配的版本，而不是一味追求信息量最大。',
  },
  {
    step: '04',
    title: '按节奏调整',
    text: '连续观看时优先保证阅读节奏稳定；若发现字幕跟不上或信息过载，可切换到阅读负担更低的版本。',
  },
];

export const faqs = [
  {
    q: '善良的小姨子在线和中文字幕是同一个意思吗？',
    a: '不完全相同。“善良的小姨子在线”偏向整体查找入口，强调可以在线浏览；而“中文字幕”强调的是语言版本，具体指把对白翻译成中文并以文本形式同步呈现。多数情况下两者会同时出现。',
  },
  {
    q: '中文字幕和中文版有什么区别？',
    a: '中文字幕保留原声对白，只在画面上叠加中文文本；中文版则更强调完整的中文呈现，句子衔接与分段更贴近中文阅读习惯。简单说，前者偏“看字幕”，后者偏“顺中文”。',
  },
  {
    q: '国语版本适合什么样的人？',
    a: '如果你不方便长时间盯着字幕阅读，或者更习惯用听的方式理解内容，国语配音版本会更合适。它把对白直接转换成了中文听觉信息。',
  },
  {
    q: '中字和双语应该怎么选？',
    a: '如果你只想快速看懂剧情，中文字幕或中字更省力；如果你希望逐句对照原声与中文的表达方式，双语字幕更适合。双语对阅读速度要求更高，建议在大屏或暂停查看时使用。',
  },
  {
    q: '字幕在线需要下载吗？',
    a: '字幕在线通常是直接随页面加载的文本形式，打开即可阅读，不需要额外下载文件。不过在线加载会受网络状况影响，连接稳定时体验更好。',
  },
  {
    q: '为什么同一部作品会有这么多语言版本？',
    a: '观众的阅读习惯和语言需求各不相同：有人看重原声语感，有人更在意理解效率。因此会出现中文字幕、中文版、国语配音、中字与双语等多种版本形式，供不同需求的人选择。',
  },
];

export const relatedTerms = [
  { text: '善良的小姨子在线', group: '入口' },
  { text: '善良的小姨子中文字幕', group: '字幕' },
  { text: '善良的小姨子字幕在线', group: '字幕' },
  { text: '善良的小姨子中文版', group: '版本' },
  { text: '善良的小姨子国语', group: '配音' },
  { text: '善良的小姨子中字', group: '字幕' },
  { text: '善良的小姨子双语', group: '字幕' },
  { text: '善良的小姨子在线观看', group: '入口' },
  { text: '善良的小姨子中文字幕在线', group: '字幕' },
  { text: '善良的小姨子国语版', group: '配音' },
  { text: '善良的小姨子双语字幕', group: '字幕' },
  { text: '善良的小姨子中字在线', group: '入口' },
];

export const navItems = [
  { id: 'profile', label: '影片档案' },
  { id: 'story', label: '剧情与看点' },
  { id: 'subtitles', label: '字幕类型' },
  { id: 'versions', label: '版本对照' },
  { id: 'languages', label: '语言说明' },
  { id: 'guide', label: '查找指南' },
  { id: 'faq', label: '常见问题' },
];